export default (amount, currency) => {
    if(currency === 'USD') return `$${amount}`;
    return `@${amount}@`;
}